import React, { useState } from 'react';
import { Icon } from '@cotera/client/app/components';

interface CopyButtonProps {
  value: string;
  title?: string;
  className?: string;
}

/**
 * Small inline button that copies `value` to the clipboard and briefly shows a
 * check icon as confirmation. Stops click propagation so it can live inside
 * clickable table rows without triggering row handlers.
 */
export const CopyButton: React.FC<CopyButtonProps> = ({
  value,
  title,
  className,
}) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = (e: React.MouseEvent) => {
    e.stopPropagation();
    void navigator.clipboard.writeText(value).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    });
  };

  return (
    <button
      type="button"
      onClick={handleCopy}
      title={title ?? `Copy ${value}`}
      className={`inline-flex items-center text-gray-400 hover:text-gray-700 ${
        className ?? ''
      }`}
    >
      <Icon icon={copied ? 'check' : 'clipboard'} className="w-3.5 h-3.5" />
    </button>
  );
};
